<template>
    <div v-if="detail" v-loading="loading">
        <headerpage :status="5"></headerpage>
    <div class="deground">
        <div class="box" :style="{height:height+'px'}">
            <img :src="detail.show_pic | addurl" style="width: 100%;height: 100%;" />
        </div>
        <div class="box1 adaptation">
            <div class="box1_left">
                <el-amap class="amap-box"  :amap-manager="amapManager"  :vid="'amap-vue'" :zoom="zoom" :center="center">
                    <el-amap-marker vid="component-marker" :position="center"></el-amap-marker>
                </el-amap>

            </div>
            <div class="box1_right">
                <div class="box1_right_t">联系我们</div>
                <div class="box1_right_t1">CONTACT US</div>
                <div class="box1_right_tt">
                    <div class="box1_right_tt_t">
                        <div class="box1_right_tt_t_left">企业名称</div>
                        <div class="box1_right_tt_t_right">{{detail.company_name}}</div>
                    </div>
                    <div class="box1_right_tt_t">
                        <div class="box1_right_tt_t_left">地址信息</div>
                        <div class="box1_right_tt_t_right">{{detail.address}}</div>
                    </div>
                    <div class="box1_right_tt_t">
                        <div class="box1_right_tt_t_left">联系电话</div>
                        <div class="box1_right_tt_t_right">{{detail.phone}}</div>
                    </div>
                    <div class="box1_right_tt_t">
                        <div class="box1_right_tt_t_left">电子邮箱</div>
                        <div class="box1_right_tt_t_right">{{detail.email}}</div>
                    </div>
                </div>
                <div class="box1_right_bot">
                    <img class="box1_right_bot_t" src="../../assets/images/qie/5.png" />
                    <div class="box1_right_bot_t1">
                        <img class="box1_right_bot_t2" :src="detail.image | addurl" />
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 30px;"></div>
    </div>
    </div>
    
</template>
  
<script>
import headerpage from '../../components/header/header.vue';
import windowchange from '@/util/window'
import { AMapManager, lazyAMapApiLoaderInstance } from 'vue-amap'
let amapManager = new AMapManager()
// import AMap from 'AMap';   //在页面中引入高德地图
export default {
    components: {headerpage},
    mixins: [windowchange],
    data() {
        return {
            height: 650,
            height1: 650,
            address: null,
            amapManager,
            center: [],
            zoom: 17,
            loaded: false,
            detail:'',
            loading:false
        }
    },
    mounted() {

    },
    methods: {
        about_us() {
            this.loading = true
            this.$https.post(
                {
                    api: this.$api.api.demo.about_us,
                    type: "formData",
                },
                {},
                (response) => {
                    this.loading = false
                    this.detail =  response.data
                    this.center[1] = response.data.latitude
                    this.center[0] = response.data.longitude
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    },
    created: function () {

        this.about_us()
    }
}
</script>
<style scoped>
.box {
    background-size: 100% 100%;
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.box1 {
    height: 561px;
    box-shadow: 2px 1px 185px 58px rgba(141, 148, 155, 0.33);
    margin-top: -160px;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    width: 100%;
}

.box1_left {
    height: 100%;
    width: 60%;
    padding: 20px;
}

.box1_right {
    width: 40%;
    height: 100%;
    background-color: #0170c1;
    padding: 45px 30px;
}

.box1_right_t {
    font-size: 20px;
    color: #ffffff;
}

.box1_right_t1 {
    font-size: 46px;
    color: #ffffff;
    opacity: 0.11;
    margin-top: 15px;
    font-weight: 600;
}

.box1_right_tt {
    margin: 40px 0;
}

.box1_right_tt_t {
    display: flex;
    /* align-items: center; */
    font-size: 16px;
    margin-bottom: 20px;
}

.box1_right_tt_t:last-child {
    margin-bottom: 0;
}

.box1_right_tt_t_left {
    color: #ffffff;
    opacity: 0.64;
}

.box1_right_tt_t_right {
    flex: 1;
    margin-left: 30px;
    color: #ffffff;
}

.box1_right_bot_t {
    width: 42px;
    height: 42px;
}

.box1_right_bot_t2 {
    width: 60px;
    height: 58px;
}

.box1_right_bot {
    display: flex;
    align-items: center;
}

.box1_right_bot_t1 {
    margin-left: 40px;
    width: 85px;
    height: 85px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: 100% 100%;
    box-shadow: 10px 7px 27px 0px rgba(141, 148, 155, 0.35);
    border-radius: 2px;
    position: relative;
}

.box1_right_bot_t1::after {
    content: '';
    width: 12px;
    height: 12px;
    position: absolute;
    transform: rotate(45deg);
    left: -6px;
    background-color: #fff;
}
</style>
  


// WEBPACK FOOTER //
// about.vue?239991a3